<template>
  <PageWrapper :isDense="isDense" :isLoading="isLoading">
    <template #title>
      <span class="mt-2"> لیست سوال های مسابقه </span>
    </template>
    <template #titleBtn>
      <BButton variant="success" @click="renderAddQuestionToMatchDialog">
        افزودن سوال به مسابقه
      </BButton>
    </template>
    <CustomTable
      v-if="matchQuestions"
      :totalCount="0"
      :tableColumns="tableColumns"
      :tableItems="matchQuestions"
      @changePage="() => {}"
    >
      <template #actions="data">
        <BButton
          variant="transparent"
          @click="renderDeleteQuestionFromMatchConfirmationDialog(data.item)"
        >
          <FeatherIcon icon="Trash2Icon" size="23" class="text-danger" />
        </BButton>
      </template>
    </CustomTable>
    <DeleteQuestionFromMatchConfirmationDialog
      :defaultSelectedQuestion="tempSelectedQuestion"
      :selectedMatch="selectedMatch"
      @refetch="refetch"
    ></DeleteQuestionFromMatchConfirmationDialog>
    <AddQuestionsToMatchDialog
      :selectedMatch="selectedMatch"
      @refetch="refetch"
    ></AddQuestionsToMatchDialog>
  </PageWrapper>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    isDense: {
      type: Boolean,
      default: false,
    },
    selectedMatch: {
      type: Object,
    },
    matchQuestions: {
      type: Array,
      required: true,
    },
  },
  watch: {
    selectedMatch: {
      handler(val) {
        console.log(val);
      },
      immediate: true,
    },
  },
  data() {
    return {
      isLoading: false,
      tableColumns: [
        {
          key: "questionId",
          label: "شناسه",
        },
        {
          key: "questionText",
          label: "متن سوال",
        },
        {
          key: "a",
          label: "جواب A",
        },
        {
          key: "b",
          label: "جواب B",
        },
        {
          key: "c",
          label: "جواب C",
        },
        {
          key: "d",
          label: "جواب D",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
      tempSelectedQuestion: null,
    };
  },
  methods: {
    refetch() {
      this.$emit("refetch");
    },
    renderAddQuestionToMatchDialog() {
      this.$bvModal.show("add-question-to-match-dialog");
    },
    renderDeleteQuestionFromMatchConfirmationDialog(selectedQuestion) {
      this.tempSelectedQuestion = selectedQuestion;
      this.$bvModal.show("delete-question-from-match-confirmation-dialog");
    },
  },
  components: {
    DeleteQuestionFromMatchConfirmationDialog,
    AddQuestionsToMatchDialog,
    PageWrapper,
    CustomTable,
    BButton,
  },
};
import DeleteQuestionFromMatchConfirmationDialog from "@/views/components/Matches/DeleteQuestionFromMatchConfirmationDialog.vue";
import AddQuestionsToMatchDialog from "@/views/components/Matches/AddQuestionsToMatchDialog.vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import { BButton } from "bootstrap-vue";
</script>
